import { InsuranceMonitor } from "@wingspanhq/wingspan-api-sdk";
import { WSQueryCache } from "@ws-react-query";

import { queriesInsuranceMonitors } from "../../../../../../v3/query/queriesInsuranceMonitors";
import { ContextItem, RequirementTableItemData } from "../../../../types";
import { INSURANCE_MONITOR_EXPAND } from "../../constants";

export const getInsuranceMonitorFromCache = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem
): InsuranceMonitor | undefined => {
  if (!requirement.dataSourceId) {
    return undefined;
  }

  // must mirror the expansions the batch read in the module index fetched
  // with — the cache key is `[apiName, methodName, request]`
  return WSQueryCache.getQueryData<InsuranceMonitor>(
    queriesInsuranceMonitors.getInsuranceMonitor.getQueryKey({
      monitorId: requirement.dataSourceId,
      expand: INSURANCE_MONITOR_EXPAND
    })
  );
};
